import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

function IconBase({ children, ...props }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="20"
      viewBox="0 0 24 24"
      width="20"
      {...props}
    >
      {children}
    </svg>
  );
}

export function LockIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <rect height="11" rx="3" stroke="currentColor" strokeWidth="1.7" width="15" x="4.5" y="10" />
      <path d="M8 10V7.5a4 4 0 0 1 8 0V10" stroke="currentColor" strokeWidth="1.7" />
    </IconBase>
  );
}

export function MicIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <rect height="12" rx="4" stroke="currentColor" strokeWidth="1.7" width="7" x="8.5" y="3" />
      <path d="M5.5 11.5a6.5 6.5 0 0 0 13 0M12 18v3M9 21h6" stroke="currentColor" strokeLinecap="round" strokeWidth="1.7" />
    </IconBase>
  );
}

export function MicOffIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="m4 4 16 16M9 5.5A3.5 3.5 0 0 1 15.5 7v3M8.5 10v1a3.5 3.5 0 0 0 5.8 2.65M5.5 11.5a6.5 6.5 0 0 0 10.1 5.4M18.5 11.5a6.5 6.5 0 0 1-.7 2.9M12 18v3M9 21h6" stroke="currentColor" strokeLinecap="round" strokeWidth="1.7" />
    </IconBase>
  );
}

export function ArrowIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M5 12h14M14 7l5 5-5 5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.7" />
    </IconBase>
  );
}

export function StopIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <rect fill="currentColor" height="10" rx="2" width="10" x="7" y="7" />
    </IconBase>
  );
}

export function SparkIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="M12 2.8c.5 4.3 2.9 6.7 7.2 7.2-4.3.5-6.7 2.9-7.2 7.2-.5-4.3-2.9-6.7-7.2-7.2 4.3-.5 6.7-2.9 7.2-7.2Z" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.5" />
      <path d="M18.5 16.5c.2 1.7 1.3 2.8 3 3-1.7.2-2.8 1.3-3 3-.2-1.7-1.3-2.8-3-3 1.7-.2 2.8-1.3 3-3Z" fill="currentColor" />
    </IconBase>
  );
}

export function SendIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <path d="m3.5 4 17 8-17 8 2.2-6.4L14 12 5.7 10.4 3.5 4Z" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.6" />
    </IconBase>
  );
}

export function CameraIcon(props: IconProps) {
  return (
    <IconBase {...props}>
      <rect height="12" rx="3" stroke="currentColor" strokeWidth="1.7" width="13" x="3" y="6" />
      <path d="m16 10.5 5-3v9l-5-3" stroke="currentColor" strokeLinejoin="round" strokeWidth="1.7" />
    </IconBase>
  );
}
